module.exports = __webpack_public_path__ + "static/jddj-05498d8b631d5eb27b2e2bbc26fa82f1.png";